import { render } from "./LoopConfigurationModal.vue?vue&type=template&id=2dfd330d&scoped=true"
import script from "./LoopConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./LoopConfigurationModal.vue?vue&type=script&lang=ts"

import "./LoopConfigurationModal.vue?vue&type=style&index=0&id=2dfd330d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2dfd330d"

export default script